import type { Embed, EmbedSize } from '@tunasong/models'
import type { IframeHTMLAttributes } from 'react'

export type LinkParser = (url?: string) => Embed | null
export type EmbedSizes = Record<EmbedSize, IframeHTMLAttributes<unknown>>

export interface ServiceApi {
  getCurrentTime?: () => number
  getDuration?: () => number
  /** Whether playback is currently paused */
  isPaused?: () => boolean
  setCurrentTime?: (time: number) => void
  setPlaybackRate?: (rate: number) => void

  setContainerWidth?: (width: number) => void
  // If `false`, do not show the IFrame since the service will render a custom block
  hideIFrame?: () => boolean

  updateEmbed?: (embed: Embed) => void
  // Cleanup at the end of the component lifecycle
  cleanup?: () => void
}

export interface ServiceEmbed {
  parse: LinkParser
  sizes: EmbedSizes
  getUrlForSize?: (embed: Embed, size: EmbedSize) => string | undefined
  /** Effect to be run on the initial embed in an useEffect */
  getApi?: (embed: Embed, el: HTMLIFrameElement, container: HTMLDivElement) => ServiceApi
}

export const parsePx = (el: HTMLElement, val: string | number | undefined, type: 'height' | 'width') => {
  if (typeof val === 'number') {
    return val
  }
  if (val?.endsWith('px')) {
    return parseInt(val, 10)
  }
  if (val?.endsWith('%') && el.parentElement) {
    const parentSize = type === 'width' ? el.parentElement.clientWidth : el.parentElement.clientHeight
    return Math.round((parseInt(val, 10) / 100) * parentSize)
  }
  return Number(val)
}
